export const CANCEL = 'cancel'

export function cancelErrorFilter(error) {
  if (error !== CANCEL) {
    throw error
  }
}
